import { useState } from 'react';
import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { EmptyStateProps } from '@optimus-web/core';
import { usePrivilege } from '@mews-commander/core';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { useCanAddOrResetCounters } from '../utils';
import { CounterTableEmptyHelper } from './CounterTableEmptyHelper';
import { creditNoteCounterColumnMapping } from './tableMapping';
import { CountersTable } from './CountersTable';
import { useCreateCreditNoteCounterDialog } from './creditNotes/modal/useCreateCreditNoteCounterDialog';
import { CreateCreditNoteCounterDialog } from './creditNotes/CreateCreditNoteCounterDialog';

export const CreditNoteCountersTable = () => {
    const [isCreditNoteDialogOpen, setIsCreditNoteDialogOpen] = useState(false);
    const openDialog = () => {
        setIsCreditNoteDialogOpen(true);
    };

    const newCreditNotDialogEnabled = useFeatureFlag(FeatureFlag.creditNoteCountersDialogRewrite);

    const [renderDialog, toggleDialog] = useCreateCreditNoteCounterDialog();
    const canAddOrResetCounters = useCanAddOrResetCounters();
    const canManageCounters = usePrivilege('manageCounters');
    const canAddCounters = canManageCounters && canAddOrResetCounters;

    const emptyState = {
        pictogram: 'folder',
        primaryText: <LocalizedText textKey={TextKey.CreditNoteCounterTabEmptyCreditNotes} />,
        secondaryText: canManageCounters ? <LocalizedText textKey={TextKey.CreditNoteCounterTabCreateSuggest} /> : null,
        action: canManageCounters ? (
            <CounterTableEmptyHelper action={() => (newCreditNotDialogEnabled ? toggleDialog() : openDialog())} />
        ) : null,
    } satisfies EmptyStateProps;

    return (
        <>
            <CountersTable
                counterTypes={[EnterpriseScopeCounterDiscriminator.CreditNoteBillCounter]}
                tableColumns={creditNoteCounterColumnMapping}
                emptyState={emptyState}
                openDialog={toggleDialog}
                showAddButton={canAddCounters}
            />
            {isCreditNoteDialogOpen ? (
                <CreateCreditNoteCounterDialog active handleClose={() => setIsCreditNoteDialogOpen(false)} />
            ) : null}
            {renderDialog()}
        </>
    );
};
